module.exports = __webpack_public_path__ + "static/img/dasuan.343415fc.png";